import { Injectable } from '@angular/core';
import { RidangoReduxAction, PowerUser } from '@ridango/core';


@Injectable()
export class PowerUserActions {
    static SET_POWER_USERS = '[Power Users]: Set Power Users';
    static SET_POWER_USERS_NORMALIZED = '[Power Users]: Set Power Users Normalized';
    static SORT_POWER_USERS = '[Power Users]: Sort Power Users';
    static RESET_POWER_USERS = '[Power Users]: Reset Power Users';
    static DELETE_POWER_USER = '[Power Users]: Delete Power User';
    setPowerUsers ( payload: PowerUser[] ): RidangoReduxAction {
        return {
            type: PowerUserActions.SET_POWER_USERS,
            payload: payload
        };
    }
    setPowerUsersNormalized ( payload: PowerUser[] ): RidangoReduxAction {
        return {
            type: PowerUserActions.SET_POWER_USERS_NORMALIZED,
            payload: payload
        };
    }
    deletePowerUser ( payload: PowerUser ): RidangoReduxAction {
        return {
            type: PowerUserActions.DELETE_POWER_USER,
            payload: payload
        };
    }
    sortPowerUsers ( payload ): RidangoReduxAction {
        return {
            type: PowerUserActions.SORT_POWER_USERS,
            payload: payload
        };
    }

    resetPowerUsers ( ): RidangoReduxAction {
        return {
            type: PowerUserActions.RESET_POWER_USERS
        };
    }

}
